import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import type { QueryConfig } from '@/lib/react-query';
import type { Court } from '@/types/api';

export const getCourts = (): Promise<{ courts: Court[] }> => {
  return api.get(`/scoreboard/v1/courts`);
};

export const getCourtsQueryOptions = () => {
  return queryOptions({
    queryKey: ['courts'],
    queryFn: () => getCourts(),
  });
};

type UseCourtsQueryOptions = {
  queryConfig?: QueryConfig<typeof getCourtsQueryOptions>;
};

export const useCourts = ({ queryConfig }: UseCourtsQueryOptions = {}) => {
  return useQuery({
    ...getCourtsQueryOptions(),
    ...queryConfig,
  });
};
